<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <!-- kvůli zanořeným modalům pro transformační funkce potřebuju z-index 0 vždy -->
    <div
      :class="{
        opened: opened.indexOf('newEndpoint') >= 0,
        'last-active': opened.indexOf('newEndpoint') === opened.length - 1
      }"
      class="side-box__inner"
      style="z-index: 0"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleEndpointConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button :class="{ disabled: !isSubtopicValid }" class="btn btn-primary" @click="createEndpoint()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("vytvoritEndpoint") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("novyEndpoint") }}</h2>
      </div>

      <NewEndpointFormFields
        ref="neFormFields"
        :endpoint="endpoint"
        :errors="errors"
        :fixed-protocol="protocol"
        :opened="opened"
        @close-box="closeBox"
        @open-box="openBox"
        @something-clicked="changedEvent"
        @subtopic-valid="isSubtopicValid = $event"
      />

      <div v-if="showDataFlows" class="d-flex side-box__row align-items-start">
        <span class="side-box__content__label mt-sm-5 pt-4">
          <div class="side-box__content__label__withTooltip">
            <InfoQuestionMark :info-tooltip-text="'tooltip_novyEndpoint_pripojenKeSkupinam'" />
            {{ $t("pripojenKeSkupinam") }}
          </div>
        </span>
        <div class="w-100 side-box__content__input border-top ml-3 pt-4">
          <div class="text-right ml-3">
            <a @click="openBox('newGroup')">{{ $t("vytvoritNovouSkupinu") }}</a>
          </div>
          <div class="side-box__content__groups mb-1">
            <div
              v-for="selectedG in selectedGroups"
              :key="selectedG.deviceGroupId"
              class="d-flex side-box__content__group justify-content-between mb-2"
            >
              <span class="mr-1 link-gray font-weight-normal">
                <span>{{ selectedG.deviceGroupName }}</span>
              </span>
              <div class="pointer" @click="addRemoveGroup(selectedG)">
                <img class="" src="@/assets/icons/actions/ico-ico-delete-gray.svg" />
              </div>
            </div>
          </div>
          <div
            v-if="selectedGroups.length < 1 || selectGroupVisible == true"
            class="side-box__content__input custom-control__select"
            @click="changedEvent"
          >
            <div
              :class="{ opened: groupsOpened }"
              class="side-box__content__input custom-control__select__selected"
              @click="groupsOpened = !groupsOpened"
            >
              <span class="gray-text">{{ $t("vyberteSkupinuZeSeznamu") }}</span>
            </div>
            <div :class="{ opened: groupsOpened }" class="custom-control__select__options">
              <div
                v-for="group in loadedGroups"
                :key="group.deviceGroupId"
                @click="
                  () => {
                    addRemoveGroup(group)
                    selectGroupVisible = false
                  }
                "
              >
                <div
                  v-if="!(selectedGroups.filter((e) => e.deviceGroupId === group.deviceGroupId).length > 0)"
                  class="custom-control__select__option d-flex align-items-center"
                >
                  <div class="check">
                    <img v-if="selectedGroups.indexOf(group) > -1" class="" src="@/assets/icons/check.svg" />
                  </div>
                  <span class="font-weight-light">{{ group.deviceGroupName }}</span>
                </div>
              </div>
              <div
                v-if="!loadedGroups.length"
                class="custom-control__select__option d-flex align-items-center gray-text"
              >
                {{ $t("SELECT_NO_DATA") }}
              </div>
            </div>
          </div>
          <div v-else>
            <a v-if="selectedGroups.length < loadedGroups.length" class="" @click="selectGroupVisible = true">
              {{ $t("pridatKDalsiSKupine") }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="{
        opened: opened.indexOf('newGroup') >= 0,
        'last-active': opened.indexOf('newGroup') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleGroupConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="createGroup()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("vytvoritRoutovaciSkupinu") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("novaRoutovaciSkupina") }}</h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.group" class="text-danger">
          {{ errors.group }}
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">{{ $t("nazevSkupiny") }}</span>
          <div
            :class="{ 'has-error': errors.group && !newGroup.deviceGroupName }"
            class="side-box__content__input custom-control__custom-input ml-3"
          >
            <span v-if="!newGroup.deviceGroupName" class="placeholder">{{ $t("zadejteNazevRotovaciSkupiny") }}</span>
            <input
              v-model="newGroup.deviceGroupName"
              autofocus
              class="w-100"
              maxlength="30"
              minlength="1"
              placeholder=""
              type="text"
              @click="changedEvent"
            />
          </div>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">{{ $t("popis") }}</span>
          <div class="side-box__content__input custom-control__custom-input ml-3">
            <span v-if="!newGroup.deviceGroupDesc" class="placeholder">{{ $t("volitelnyPopisRoutovaciSkupiny") }}</span>
            <input
              v-model="newGroup.deviceGroupDesc"
              autofocus
              class="w-100"
              maxlength="255"
              placeholder=""
              type="text"
              @click="changedEvent"
            />
          </div>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedEndpointConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleEndpointConfirmation"
      @no="closeBox()"
      @yes="createEndpoint()"
    />
    <SaveConfirmationModal
      :opened="openedGroupConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleGroupConfirmation"
      @no="
        () => {
          clearGroup()
          closeBox('newGroup')
        }
      "
      @yes="createGroup()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal
        :centered="true"
        :errors="errorsToTranslate"
        :opened="openedError"
        @close="
          () => {
            openedError = false
            closeBox()
          }
        "
      />
    </div>
    <div v-if="errorsToTranslate1.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate1" :opened="openedError1" @close="openedError1 = false" />
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import InfoQuestionMark from "@/components/info/infoQuestionMark.vue"

import NewEndpointFormFields from "@/components/modals/endpoints/NewEndpointFormFields.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    SaveConfirmationModal,
    ErrorModal,
    InfoQuestionMark,
    NewEndpointFormFields
  },
  props: {
    protocol: {
      type: String,
      default: ""
    },
    showDataFlows: {
      type: Boolean,
      required: false,
      default: true
    },
    tags: Array,
    opened: Array
  },
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      changed: false,
      endpoint: {
        projectId: "",
        custDestName: "",
        custDestDescription: "",
        custDestParameters: {
          // FIXME měnit fieldy podle parametru, aby bylo reaktivní isEndpointValid
          url: "",
          auth: "",
          headers: {
            "Content-Type": "application/json"
          },
          address: ""
        },
        custDestEnabled: true,
        transformationId: null
      },
      loadedGroups: [],
      selectedGroups: [],
      groupsOpened: false,
      transformsOpened: false,
      parametersTagsOpened: false,
      parametersOpened: false,
      selectedParameters: [],
      tagsOpened: false,
      selectedEndpointTags: [],
      selectedGroupTags: [],
      groupTags: [],
      writtenEndpointTags: "",
      writtenGroupTags: "",
      newGroup: {
        projectId: "",
        deviceGroupName: "",
        deviceGroupDesc: ""
      },
      openedEndpointConfirmation: false,
      openedGroupConfirmation: false,
      errors: {
        endpoint: "",
        group: "",
        transform: ""
      },
      selectGroupVisible: false,
      errorsToTranslate: [],
      openedError: false,
      openedError1: false,
      errorsToTranslate1: [],
      isEndpointValid: false,
      isSubtopicValid: true
    }
  },
  computed: {
    project() {
      return this.projectStore.selectedProject
    }
  },
  watch: {
    slides() {},
    project: {
      handler(project) {
        if (!project) {
          return
        }

        this.setProject()
      },
      immediate: true
    },
    writtenEndpointTags() {
      this.createTagsArray()
    },
    opened() {
      if (this.opened.indexOf("newEndpoint") > -1) {
        this.loadGroups()
      }
    },
    endpoint: {
      handler() {
        console.log(1)
        this.checkValidity()
      },
      deep: true
    }
  },
  methods: {
    checkValidity() {
      const protocol = this.endpoint.protocol || this.protocol

      if (!protocol) {
        this.isEndpointValid = false
        return
      }

      if (protocol === "HTTP") {
        this.isEndpointValid = !!(this.endpoint.custDestName && this.endpoint.custDestParameters.url)
        return
      }

      if (protocol === "MQTT") {
        this.isEndpointValid = !!(this.endpoint.custDestName && this.endpoint.custDestParameters.address)
        return
      }

      this.isEndpointValid = false
    },
    changedEvent() {
      this.changed = true
    },
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box == undefined) {
        this.emptyEndpoint()
        this.$emit("closeBox")
      } else {
        this.errors.group = ""
        this.$emit("closeBox", box)
      }
    },
    setProject() {
      this.endpoint.projectId = this.project.projectId
      this.newGroup.projectId = this.project.projectId
    },
    loadGroups() {
      axios
        .get(
          process.env.VUE_APP_API +
            "/device-groups?projectId[eq]=" +
            this.project.projectId +
            "&limit=1000&sort=%2BdeviceGroupName",
          {}
        )
        .then((result) => {
          this.loadedGroups = result.data.data

          this.getAllTags()
        })
        .catch(() => {})
    },
    addRemoveGroup(group) {
      if (!this.selectedGroups.includes(group)) {
        this.selectedGroups = this.selectedGroups.concat([group])
      } else {
        this.selectedGroups = this.selectedGroups.filter((g) => g.deviceGroupId !== group.deviceGroupId)
      }
      //
    },
    addRemoveParameter(parameter) {
      if (!this.selectedParameters.includes(parameter)) {
        this.selectedParameters = this.selectedParameters.concat([parameter])
      } else {
        this.selectedParameters = this.selectedParameters.filter((p) => p !== parameter)
      }
    },
    addRemoveTag(tag) {
      if (!this.writtenEndpointTags.includes(tag)) {
        this.writtenEndpointTags += tag
      }
    },
    createTagsArray() {
      let written = this.writtenEndpointTags.split(",")
      let selected = []
      written.forEach((tag) => {
        let trimmed = tag.trim()
        selected.push(trimmed)
      })
      this.selectedEndpointTags = selected
    },
    async createEndpoint() {
      this.errorsToTranslate = []
      this.setProject()

      const protocol = this.protocol || this.endpoint.protocol

      if (this.isEndpointValid) {
        const postUrl = `${process.env.VUE_APP_API}${protocol === "HTTP" ? "/http/endpoints" : "/mqtt/gateways"}`

        try {
          const result = await axios.post(postUrl, this.endpoint)

          let endpointId = result.data.custDestId
          let selectedGroupsId = this.selectedGroups.map((d) => d.deviceGroupId)
          if (selectedGroupsId.length < 1) {
            this.$emit("reloadItems")
            this.emptyEndpoint()
          }

          for (const groupId of selectedGroupsId) {
            try {
              await axios.post(`${process.env.VUE_APP_API}/device-groups/${groupId}/endpoints/${endpointId}/assign`)
            } catch (e) {
              console.error(e)
            }
            this.emptyEndpoint()
            this.$emit("reloadItems")
          }

          this.$refs.neFormFields.resetProtocol()
          this.$emit("saved", { endpointId: result.data.custDestId, protocol })
        } catch (error) {
          this.errorsToTranslate1.push(error.data)
          this.openedError1 = true
        }
      } else {
        this.errors.endpoint = this.$t("fillAllFieldsError")
      }
    },

    createGroup() {
      this.errorsToTranslate1 = []
      if (this.newGroup.deviceGroupName) {
        axios
          .post(process.env.VUE_APP_API + "/device-groups", this.newGroup, {})
          .then((result) => {
            let groupId = result.data.deviceGroupId

            let createdGroup = Object.assign(this.newGroup)
            createdGroup.deviceGroupId = groupId
            this.clearGroup()
            this.loadedGroups = this.loadedGroups.concat([createdGroup])
            this.selectedGroups = this.selectedGroups.concat([createdGroup])
            this.$emit("closeBox", "newGroup")
          })
          .catch((error) => {
            this.errorsToTranslate1 = this.errorsToTranslate1.concat([error.data])
            this.openedError1 = true
          })
      } else {
        this.errors.group = this.$t("fillAllFieldsError")
      }
    },
    getAllTags() {
      this.groupTags = _(this.loadedGroups)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
    },
    toggleEndpointConfirmation() {
      console.log("toggleEndpointConfirmation")
      console.log(this.changed)
      if (this.changed) {
        this.openedEndpointConfirmation = !this.openedEndpointConfirmation
      } else {
        this.openedEndpointConfirmation = false
        this.$emit("closeBox")
      }
    },
    toggleGroupConfirmation() {
      console.log("toggleGroupConfirmation")
      console.log(this.changed)
      if (this.changed) {
        this.openedGroupConfirmation = !this.openedGroupConfirmation
      } else {
        this.openedGroupConfirmation = false
        this.$emit("closeBox", "newGroup")
      }
    },
    resetValues() {
      this.groupsOpened = false
      this.parametersTagsOpened = false
      this.parametersOpened = false
      this.tagsOpened = false
      this.errors.endpoint = ""
      this.selectedGroups = []
    },
    emptyEndpoint() {
      this.errors.endpoint = ""
      this.endpoint = {
        projectId: "",
        custDestName: "",
        custDestDescription: "",
        custDestParameters: {
          url: "",
          auth: "",
          headers: {
            "Content-Type": "application/json"
          },
          address: ""
        },
        custDestEnabled: true,
        transformationId: null,
        tags: ["svetlo"]
      }
      this.selectedGroups = []
    },
    clearGroup() {
      this.newGroup = {
        projectId: "",
        deviceGroupName: "",
        deviceGroupDesc: ""
      }
      this.errors.group = ""
      this.setProject()
    }
  }
}
</script>
